import { Pipe, PipeTransform } from '@angular/core';
import { AppRootContext } from '../bootstrap';

const isPredefinedImage = function (image) {
    return image && image.indexOf('desktop') >= 0;
};



@Pipe({
    name: 'desktopBackgroundImageUrl'
})
export class DesktopBackgroundImageUrlPipe implements PipeTransform {
    constructor(private appRootContext: AppRootContext) {}

    transform(imagePath: string, size?: any) {
        return this.appRootContext.globalInfo.config.box.baseUrl +
            '/background-image/' +
            imagePath +
            (size ? size : '') +
            '/from-s3';
    }
}

@Pipe({
    name: 'isCustomizeDesktopBackground'
})
export class IsCustomizeDesktopBackgroundPipe implements PipeTransform {
    transform(backgroundImage: string) {
        if (backgroundImage && !isPredefinedImage(backgroundImage)) {
            return true;
        } else {
            return false;
        }
    }
}